import { render, staticRenderFns } from "./PublicNavMenuHeaderLink.vue?vue&type=template&id=98681798&"
import script from "./PublicNavMenuHeaderLink.vue?vue&type=script&lang=js&"
export * from "./PublicNavMenuHeaderLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports